import { useQuery } from '@tanstack/react-query'
import { QueryParsed } from '../commons/useQuery'
import { api } from '@/utils/api'
import { createRouteForAPI } from '@/utils/helpers/urlHelper'
import { apiTransactionsItems } from '@/utils/api/url'
import { ResTransactionItemCalendar } from '@/types/transaction'

export const QUERY_KEY_APPOINTMENT_ITEMS = 'QUERY_KEY_APPOINTMENT_ITEMS'
export const useGetAppointmentItems = ({
  params,
  branch,
}: {
  branch: string
  params: QueryParsed
}) => {
  const transactionItems = useQuery({
    refetchOnReconnect: true,
    queryKey: [QUERY_KEY_APPOINTMENT_ITEMS, JSON.stringify(params)],
    queryFn: () =>
      api
        .get(createRouteForAPI(apiTransactionsItems, { branch }), { params })
        .then(({ data }) => data as ResTransactionItemCalendar[]),
  })
  return transactionItems
}
